module.exports = "/static/images/BRT-logo-2022.png";